import React from 'react';
import { Dialog } from '@dynamon-as/ui';
import { Conflict, ConflictSeverity } from '@features/requests/types';
import styles from './ConflictWarning.module.css';

/**
 * Props for ConflictWarning component
 */
export interface ConflictWarningProps {
    /** List of conflicts to display */
    conflicts: Conflict[];
    /** Callback when user confirms */
    onConfirm: () => void;
    /** Callback when user cancels */
    onCancel: () => void;
    /** Whether the dialog is open */
    open: boolean;
}

/**
 * Modal for displaying non-blocking conflicts (warnings)
 * Allows user to confirm or cancel the action
 */
export function ConflictWarning({
    conflicts,
    onConfirm,
    onCancel,
    open,
}: ConflictWarningProps): React.ReactElement {
    // Filter to only show warnings (non-blocking conflicts)
    const warnings = conflicts.filter(
        (c): boolean => c.severity === ConflictSeverity.WARNING,
    );

    // Get unique warning messages
    const uniqueWarnings = Array.from(
        new Set(warnings.map((w): string => w.message)),
    );

    return (
        <Dialog
            open={open}
            onClose={onCancel}
            title="Advarsel"
            onConfirm={onConfirm}
            confirmText="Bekreft"
            cancelText="Avbryt"
            danger={false}
        >
            <div className={styles.container}>
                <p className={styles.message}>
                    Du har advarsler som krever bekreftelse:
                </p>
                <ul className={styles.list}>
                    {uniqueWarnings.map(
                        (warning, index): React.ReactElement => (
                            <li
                                key={index}
                                className={styles.item}
                            >
                                {warning}
                            </li>
                        ),
                    )}
                </ul>
                <p className={styles.question}>Ønsker du å fortsette?</p>
            </div>
        </Dialog>
    );
}
